<sibat-widget *transloco="let t; read: 'cockpit.ongoingControlsWidget'" [title]="t('title')" [width]="'large-widget'">
  <mat-icon widget-icon>pending_actions</mat-icon>
  <div widget-content>
    @if (isEmpty$ | async) {
    <p class="empty-message">{{ t('empty') }}</p>
    } @else {
    <div class="table-container" [class.expanded]="showAll$ | async">
      <table class="single-action-list" mat-table [dataSource]="displayedSummaries$ | async">
        <ng-container matColumnDef="buildingId">
          <th mat-header-cell *matHeaderCellDef>{{ t('buildingId') }}</th>
          <td mat-cell *matCellDef="let element">{{ element.buildingId }}</td>
        </ng-container>
        <ng-container matColumnDef="egids">
          <th mat-header-cell *matHeaderCellDef>{{ t('egid') }}</th>
          <td mat-cell *matCellDef="let element">{{ element.egids.join(', ') }}</td>
        </ng-container>
        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef>{{ t('address') }}</th>
          <td mat-cell *matCellDef="let element">
            @for (addressLine of element.addresses?.at(0)?.split(','); track addressLine) {
            <div class="address-line">
              {{ addressLine }}
            </div>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="municipality">
          <th mat-header-cell *matHeaderCellDef>{{ t('municipality') }}</th>
          <td mat-cell *matCellDef="let element">{{ element.municipality }}</td>
        </ng-container>
        <ng-container matColumnDef="controlDate">
          <th mat-header-cell *matHeaderCellDef>{{ t('controlDate') }}</th>
          <td mat-cell *matCellDef="let element">{{ element.controlDate | date : 'dd.MM.yyyy' }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="displayBuilding(row.buildingId)"></tr>
      </table>
    </div>
    @if (hasMoreThanTop$ | async) {
    <div class="show-all-container">
      <sibat-tertiary-button
        [label]="(showAll$ | async) ? t('showLess') : t('showAll')"
        (clicked)="toggleShowAll()"
        data-testid="toggle-show-all"
      ></sibat-tertiary-button>
    </div>
    } }
  </div>
</sibat-widget>
